import script from "./login_code.vue?vue&type=script&lang=ts&setup=true"
export * from "./login_code.vue?vue&type=script&lang=ts&setup=true"

import "./login_code.vue?vue&type=style&index=0&id=2999f560&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2999f560"]])

export default __exports__